import { 
	GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCESSES, 
	GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCESS,
	CREATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCESS,
	UPDATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCESS,
	DESTROY_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCESS,
} from "./actions"

export function ProjectQaWeldingInspectionsWeldingProcessesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCESSES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCESS}_FULFILLED`:
		case `${CREATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCESS}_FULFILLED`:
		case `${UPDATE_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCESS}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_QA_WELDING_INSPECTIONS_WELDING_PROCESS}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectQaWeldingInspectionsWeldingProcessesReducer } from "modules/project/qa/welding_inspections/welding_processes/reducer"

// project_qa_welding_inspections_welding_processes:ProjectQaWeldingInspectionsWeldingProcessesReducer,
